import { useState } from "react";
import AutoSearch  from "./AutoSearch";
import PartsSearch from "./PartsSearch";
import BuyACar     from "./BuyACar";

const SUBMENUS = [
  {
    key:      "repair",
    label:    "Repair Helper",
    icon:     "🔧",
    tagline:  "Fix it cheap — DIY, YouTube, fair prices",
    component: <AutoSearch />,
  },
  {
    key:      "parts",
    label:    "Parts Finder",
    icon:     "🔩",
    tagline:  "Compare parts prices across 8 stores",
    component: <PartsSearch />,
  },
  {
    key:      "buy",
    label:    "Buy a Car",
    icon:     "🛒",
    tagline:  "See what the dealer paid, negotiate better",
    component: <BuyACar />,
  },
];

export default function AutoTab() {
  const [active, setActive] = useState("repair");
  const current = SUBMENUS.find(s => s.key === active);

  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif" }}>
      {/* Submenu bar */}
      <div style={{ display: "flex", gap: 8, marginBottom: 20, padding: "6px", background: "#f1f5f9", borderRadius: 14 }}>
        {SUBMENUS.map(sub => (
          <button key={sub.key} onClick={() => setActive(sub.key)} style={{
            flex: 1, padding: "10px 8px", borderRadius: 10, border: "none", cursor: "pointer",
            background: active === sub.key ? "#fff" : "transparent",
            boxShadow: active === sub.key ? "0 1px 4px rgba(0,0,0,0.10)" : "none",
            transition: "all 0.15s",
          }}>
            <div style={{ fontSize: 18, marginBottom: 3 }}>{sub.icon}</div>
            <div style={{ fontSize: 12, fontWeight: 700, color: active === sub.key ? "#1d4ed8" : "#6b7280" }}>{sub.label}</div>
            <div style={{ fontSize: 10, color: active === sub.key ? "#60a5fa" : "#9ca3af", marginTop: 1, lineHeight: 1.3 }}>{sub.tagline}</div>
          </button>
        ))}
      </div>

      {/* Active submenu content */}
      {current?.component}
    </div>
  );
}
